import axios from "axios";

async function getDeliveryZone(dealerApiBase, dealerId, postalCode, state, lat, lng, subtotal) {
  const url = `${dealerApiBase}delivery/zone/`
  const result = await axios.post(url, {
    dealerId,
    postalCode,
    state,
    lat,
    lng,
    subtotal
  })
  return result.data;
}

async function getSettings(dealerApiBase, dealerId, attributeIds) {
  const filter = {
    dealerId,
    attributeIds
  };
  const qs = '?' + new URLSearchParams(filter).toString();
  const result = await axios.get(`${dealerApiBase}delivery/settings/${qs}`);
  return result.data;
}

async function getInventory(dealerApiBase, dealerId, attributeIds) {
  const filter = {
    dealerId,
    attributeIds
  };
  const qs = '?' + new URLSearchParams(filter).toString();
  const result = await axios.get(`${dealerApiBase}inventory/${qs}`);
  return result.data;
}

export default {
  getDeliveryZone,
  getSettings,
  getInventory
};
